/* eslint-disable no-console */
import { AUTOMATIC_PRICE_DEBUG_SESSION_KEY } from './StagePrice.config';

export const createAutomaticPriceLogger = () => {
  const isAutomaticPriceLogEnabled =
    console &&
    typeof console.log === 'function' &&
    window.sessionStorage.getItem(AUTOMATIC_PRICE_DEBUG_SESSION_KEY);
  return (message: string, ...additionalLogs: unknown[]): void => {
    if (isAutomaticPriceLogEnabled) {
      console.log(`%c[STAGE AUTOMATIC PRICE]%c :: ${message}`, 'font-weight:bold;', '', ...additionalLogs);
    }
  };
};
